<template>
  <div id="app">
    <div id="logo" v-if="['welcome', 'edwedewd'].indexOf($route.name) < 0"><img src="./assets/img/kigebu-logo.png"></div>
    <div id="nav" v-if="['welcome', 'edwedewd'].indexOf($route.name) < 0">
      <router-link id="home" to="/">Party</router-link>
      <router-link id="guests" to="/guests">Gäste</router-link>
      <router-link id="wishlist" to="/wishlist">Wunschliste</router-link>
<!--       <router-link id="chat" to="/chat">Chat</router-link> -->
<!--       <router-link id="gallery" to="/gallery">Gallery</router-link> -->
    </div>
    <transition :name="transitionName">
      <router-view/>
    </transition>
  </div>
</template>
<script>
  // v-if="['ewdwed', 'edwedewd'].indexOf($route.name) > -1"
export default {
name: "App",
  data () {
    return {
      transitionName: 'slide-left'
    }
  },
  beforeRouteUpdate (to, from, next) {
    const toDepth = to.path.split('/').length
    const fromDepth = from.path.split('/').length
    this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left'
    next()
  },
  beforeCreate(){
    //console.log('beforeCreate Hook');
    //console.log('cookie: ' + this.$cookie.get('party') );
    //console.log( this.$route.params.id == undefined );
    //console.log( this.$cookie.get('party').indexOf('-') )
    
    var self = this;
    var newParty = false;
    if( this.$route.params.id != undefined && this.$route.params.id.indexOf('-') == 0 ) {
        console.log('get param: ' + this.$route.params.id)
        newParty = true;
   
   
   
        this.$store.state.currentParty = this.$route.params.id; 
        
        if( this.$cookie.get('party') && this.$cookie.get('party').currentParty == this.$route.params.id ) {
            this.$store.state.userfacts = JSON.parse(this.$cookie.get('party'));
          } else {
            var cookieee = JSON.stringify({ 'currentParty': this.$store.state.currentParty, 'kid': null, 'gift': null, 'comes':null })
            this.$cookie.set('party', cookieee, 30);  
          }
          
        
      this.$router.push('/welcome')
      
      
    } 
    else if ( this.$cookie.get('party')  && newParty !== true ) { // 
        //console.log('got cookie');
        //console.log(  JSON.parse( JSON.stringify({ currentParty: (this.$store.state.currentParty), kid: null }) ) )
        this.$store.state.currentParty = JSON.parse(this.$cookie.get('party')).currentParty;
        this.$store.state.userfacts = JSON.parse(this.$cookie.get('party'));
        
/*
        if( this.$route.params.id.indexOf('-') != -1 )
          this.$router.push('/')
*/
    } 
    else {
        console.error('no party');
    }


    //this.$cookie.get('party')
  }
}
</script>
<style lang="scss">
/* cyrillic */
@font-face {
  font-family: 'Neucha';
  font-style: normal;
  font-weight: 400;
  src: local('Neucha'), url(https://fonts.gstatic.com/s/neucha/v9/q5uGsou0JOdh94bfuQltKRZUgbxR.woff2) format('woff2');
  unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
}
/* latin */
@font-face {
  font-family: 'Neucha';
  font-style: normal;
  font-weight: 400;
  src: local('Neucha'), url(https://fonts.gstatic.com/s/neucha/v9/q5uGsou0JOdh94bfvQltKRZUgQ.woff2) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
/*! normalize.css v8.0.0 | MIT License | github.com/necolas/normalize.css */
button,hr,input{overflow:visible}progress,sub,sup{vertical-align:baseline}[type=checkbox],[type=radio],legend{box-sizing:border-box;padding:0}html{line-height:1.15;-webkit-text-size-adjust:100%}body{margin:0}h1{font-size:2em;margin:.67em 0}hr{box-sizing:content-box;height:0}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}a{background-color:transparent}abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}b,strong{font-weight:bolder}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative}sub{bottom:-.25em}sup{top:-.5em}img{border-style:none}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;line-height:1.15;margin:0}button,select{text-transform:none}[type=button],[type=reset],[type=submit],button{-webkit-appearance:button}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{border-style:none;padding:0}[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring,button:-moz-focusring{outline:ButtonText dotted 1px}fieldset{padding:.35em .75em .625em}legend{color:inherit;display:table;max-width:100%;white-space:normal}textarea{overflow:auto}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}details{display:block}summary{display:list-item}[hidden],template{display:none}

* {
    -ms-box-sizing: border-box;
    -o-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }

body, html { margin: 0; padding: 0; font-size: 16px; height: 100%; background: #fff; }

.columns {}
.column { padding: 0.93333333em; }

#app {
  font-family: 'Neucha', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.page { max-width: 30em; margin: 0 auto;
    padding: 0.63333em 0 6em;
    min-height: 100vh;
 }
 a { color: #2c3e50; transition: color 0.3s ease-in-out; text-decoration: none; }
 a:hover { color: #369fb4; }
 
 a.button { display: inline-block; color: #369fb4; background: #fff; font-weight:bold; padding: 0.633333em 0.733333333em 0.333333em; border-radius: 5px; border: 2px solid #fcac1f; cursor:pointer;}
 a.button:hover { color: #fcac1f ; }
 
 .actions { padding: 0.233333333em; } 
#logo {
  position: fixed;
  top: 0.9333333em;
  left: 0.933333em;
  width: 4.4444em;
  z-index: 19;
    img {
      display: block;
      max-width: 100%;
    }
}
#nav {
  position: fixed;
  left: 0; right: 0; bottom: 0;
  padding: 0.63333em 0.933333em 0.9333333em;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-around;
  text-indent: 0;
  z-index: 10;
  box-shadow: 0 0 6px rgba(0,0,0,0.4);
    a {
      display: block;
      font-weight: bold;
      color: #2c3e50;
      width: 5em; height: 2.6em;
      border-radius: 0;
	  padding: 2.833333em 0 0.433333em;
	  font-size: 0.8rem;
	  color: #777;
        &#home {
          background: url(./assets/img/kigebu-icon-home.svg) center 0.3111em no-repeat;
          background-size:2.23em; }
        &#home.router-link-exact-active {
          background-image: url(./assets/img/kigebu-icon-home-hover.svg); }
        &#guests {
          background: url(./assets/img/kigebu-icon-guests.svg) center top no-repeat;
          background-size:2.033em;}
        &#guests.router-link-exact-active {
          background-image: url(./assets/img/kigebu-icon-guests-hover.svg); }
        &#wishlist {
          background: url(./assets/img/kigebu-icon-wishlist.svg) center top no-repeat;
          background-size:1.633em; }
        &#wishlist.router-link-exact-active {
          background-image: url(./assets/img/kigebu-icon-wishlist-hover.svg);}
        &#chat {
          background: url(./assets/img/kigebu-icon-chat.svg) center center no-repeat;
          background-size:80%; }
        &#chat.router-link-exact-active {
          background-image: url(./assets/img/kigebu-icon-chat-hover.svg); }
        &#gallery {
          background: url(./assets/img/kigebu-icon-gallery.svg) center center no-repeat;
          background-size:65%; }
        &#gallery.router-link-exact-active {
          background-image: url(./assets/img/kigebu-icon-gallery-hover.svg); }
  }
  a.router-link-exact-active,
  a:hover { color: #369fb4; }
}
h1 {font-size: 1.4433333rem; padding: 0.3333333em; }
.legals p { font-size: 0.7rem; line-height: 1.5; }



.fade-enter-active, .fade-leave-active {
  transition-property: opacity;
  transition-duration: .35s;
}

.fade-enter-active {
  transition-delay: .35s;
}

.fade-enter, .fade-leave-active {
  opacity: 0
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s ease;
}
.fade-enter, .fade-leave-active {
  opacity: 0
}
.child-view {
  position: absolute;
  transition: all .5s cubic-bezier(.55,0,.1,1);
}
.slide-left-enter, .slide-right-leave-active {
  opacity: 0;
  -webkit-transform: translate(30px, 0);
  transform: translate(30px, 0);
}
.slide-left-leave-active, .slide-right-enter {
  opacity: 0;
  -webkit-transform: translate(-30px, 0);
  transform: translate(-30px, 0);
}
.chevron::before {
	border-style: solid;
	border-width: 0.15em 0.15em 0 0;
	border-color: #369fb4;
	content: '';
	display: inline-block;
	height: 0.45em;
	left: 0.15em;
	position: relative;
	top: 0.15em;
	transform: rotate(-45deg);
	vertical-align: top;
	width: 0.45em;
}

.chevron.right:before {
	left: 0;
	transform: rotate(45deg);
}

.chevron.bottom:before {
	top: 0;
	transform: rotate(135deg);
}

.chevron.left:before {
	left: 0.25em;
	transform: rotate(-135deg);
}

</style>
